import React from 'react'
import { Body, Box } from '../layout'
import { Icon } from './Icon'
import './Pill.css'

export const Pill = ({ text, icon, iconColor = 'black', color = 'white', background = 'blue', small, start: { left, right, top, rotate } = {}, transition, transitionDelay, transform, active }) => (
  <Box
    position={top ? 'absolute' : ''}
    top={top}
    left={left && 0}
    right={right && 0}
    rotate={rotate}
    opacity={(transition && active || !transition) ? 1 : 0.5}
    transition={active && 'transform 1s ease, opacity 1s'}
    transform={active && transform}
    style={(active && transitionDelay) && { transitionDelay }}
  >
    <Box
      className={small ? 'small' : 'large'}
      r={60}
      background={background}
      gap={8}
      alignItems="center"
    >
      {icon && <Icon icon={icon} fill={iconColor} size={24}/>}
      <Body color={color} noWrap>{text}</Body>
    </Box>
  </Box>
)